import axios from "axios";
import { returnAxiosHeaders } from "./fns";

async function saveAction(
  context,
  payload,
  url,
  saveCommand,
  extraParameters = null
) {
  try {
    context.commit("SET_LOADING", true, { root: true });
    // Deep clone of payload
    const payloadObject = JSON.parse(JSON.stringify(payload));
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      payloadObject._id = response.data;
      payloadObject.context = context;
      context.commit(saveCommand, payloadObject);
      context.commit("SET_LOADING", false, { root: true });
      return "Success";
    } else {
      return response.data;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return error;
  }
}

async function saveActionComplete(
  context,
  payload,
  url,
  saveCommand,
  extraParameters = null
) {
  try {
    context.commit("SET_LOADING", true);
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };

    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      context.commit(saveCommand, response.data);
      context.commit("SET_LOADING", false);
      return "Success";
    } else {
      return response.data;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return error;
  }
}

async function saveActionCompleteResponse(
  context,
  payload,
  url,
  saveCommand,
  extraParameters = null
) {
  try {
    context.commit("SET_LOADING", true);
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };

    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      payload.context = context;
      context.commit(saveCommand, response.data);
      context.commit("SET_LOADING", false);
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return error;
  }
}

async function saveActionCompleteResponseContext(
  context,
  payload,
  url,
  saveCommand,
  extraParameters = null
) {
  try {
    context.commit("SET_LOADING", true);
    // Deep clone of payload
    const payloadObject = JSON.parse(JSON.stringify(payload));
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };

    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      payloadObject._id = response.data;
      payloadObject.context = context;
      context.commit(saveCommand, payloadObject);
      context.commit("SET_LOADING", false);
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response;
    return error;
  }
}

async function getAction(context, url, saveCommand, extraParameters = null) {
  try {
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let payload = {
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      payload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      payload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    if (response.status === 200) {
      context.commit(saveCommand, response.data);
      return "Success";
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    console.log(error);

    if (error.response) return error.response.data;
    return "Error";
  }
}

async function getActionLoading(
  context,
  url,
  saveCommand,
  extraParameters = null
) {
  try {
    context.commit("SET_LOADING", true);
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let payload = {
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      payload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      payload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    if (response.status === 200) {
      context.commit("SET_LOADING", false);
      context.commit(saveCommand, response.data);
      return "Success";
    } else {
      return response.data;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return "Error";
  }
}

async function genericAction(context, payload, url, extraParameters = null) {
  try {
    context.commit("SET_LOADING", true);
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      context.commit("SET_LOADING", false);
      return "Success";
    } else {
      return response.data;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return "Error";
  }
}

async function genericActionNoLoading(
  context,
  payload,
  url,
  extraParameters = null
) {
  try {
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      return "Success";
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return "Error";
  }
}

async function genericActionNoMutation(
  context,
  payload,
  url,
  extraParameters = null,
  logoutFunction = false
) {
  try {
    context.commit("SET_LOADING", true);
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    context.commit("SET_LOADING", false);
    if (response.status === 200) {
      context.commit("SET_LOADING", false);
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    context.commit("SET_LOADING", false);
    if (error.response && error.response.data === "Logout" && !logoutFunction) {
      await context.dispatch("LOGOUT");
      await context.dispatch("LOGOUT_DATABASE");
      return;
    }
    return error;
  }
}

async function genericActionNoMutationNoLoading(
  context,
  payload,
  url,
  extraParameters = null
) {
  try {
    /**
     * Set all the required information in the payload of the call
     * so the security token can be validated
     */
    let savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };
    if (extraParameters) {
      savePayload.extraParameters = extraParameters;
    }
    let response = await axios.post(
      url,
      savePayload,
      returnAxiosHeaders(context.rootState.Main.user.token)
    );
    /**
     * Check status of the response and save data on success
     */
    if (response.status === 200) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data === "Logout") {
      await context.dispatch("LOGOUT_DATABASE");
      await context.dispatch("LOGOUT");
      return;
    }
    if (error.response) return error.response.data;
    return "Error";
  }
}

async function streamAction(context, payload, url, streamHandler) {
  try {
    const savePayload = {
      objectSave: payload,
      companyMainName: context.rootState.Main.user.companyMainName,
      email: context.rootState.Main.user.email,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-token": context.rootState.Main.user.token,
      },
      body: JSON.stringify(savePayload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const { value, done } = await reader.read();

      if (done) {
        console.log("Stream complete");
        break;
      }

      buffer += decoder.decode(value, { stream: true });

      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";

      for (const part of parts) {
        const lines = part.split("\n");
        const dataLines = lines
          .filter((line) => line.startsWith("data: "))
          .map((line) => line.slice(6));

        for (const dataLine of dataLines) {
          try {
            const data = JSON.parse(dataLine);
            await streamHandler(data);
          } catch (e) {
            console.error("Error parsing SSE data:", e, dataLine);
          }
        }
      }
    }

    return "Success";
  } catch (error) {
    console.error("Stream error:", error);
    return error;
  }
}

export {
  saveAction,
  getAction,
  genericAction,
  saveActionComplete,
  saveActionCompleteResponse,
  saveActionCompleteResponseContext,
  genericActionNoMutation,
  genericActionNoLoading,
  genericActionNoMutationNoLoading,
  getActionLoading,
  streamAction,
};
